import swal from 'sweetalert2';
import notification from './notifications';

require('./bootstrap');
require('./components/menus');
// require('./components/animations');

window.Swal = swal;
notification();
